import {
  ComingSoonTag,
  Icon,
  PopoverListButtonItem,
} from '@aibees/shared/components';
import { EnrichTableActionType as Action } from './types';

export const ENRICH_ACTION_MENU_ITEMS: PopoverListButtonItem[] = [
  {
    label: 'View in search',
    key: Action.view,
    icon: <Icon name="view" size={14} color="primary" />,
  },
  {
    label: 'Report',
    key: Action.report,
    icon: <Icon name="info-circle-outline" size={14} color="primary" />,
    endItem: <ComingSoonTag />,
    disabled: true,
  },
];
